import React, { useState } from 'react'
import Select from 'react-select'
import { usePermissionCategories } from 'api/hooks/use-permission-categories'

function Category({ params, setParams }) {
  const { isSuccess, data: categories } = usePermissionCategories({ options: { refetchOnWindowFocus: false } })
  const [selected, setSelected] = useState(null)

  const options = isSuccess
    ? categories.map((category) => ({ label: category, value: category }))
    : []

  return (
    <Select
      options={options}
      value={selected}
      isClearable={true}
      placeholder="Select Function"
      onChange={(val) => {
        setSelected(val)
        setParams({ ...params, category: val?.value || '' })
      }}
      styles={{ menu: (base) => ({ ...base, zIndex: 20 }) }}
    />
  )
}

export default Category
